import { render } from "./AdminProfile.vue?vue&type=template&id=5dfe063d"
import script from "./AdminProfile.vue?vue&type=script&lang=js"
export * from "./AdminProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Layouts/TopHeader/AdminProfile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5dfe063d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5dfe063d', __exports__)) {
    api.reload('5dfe063d', __exports__)
  }
  
  module.hot.accept("./AdminProfile.vue?vue&type=template&id=5dfe063d", () => {
    api.rerender('5dfe063d', render)
  })

}


export default __exports__